module.exports = __webpack_public_path__ + "img/testbg.91d0cc35.jpg";